import React from 'react';
import 'antd/dist/antd.css';
import { useSelector } from 'react-redux';

import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import packageJson from "../../package.json";
import { getImageUrl } from "../functions/generalFunctions";
const { Sider } = Layout;
const { SubMenu } = Menu;

const Sidebar = ({ collapsed }) => {
  const appStore = useSelector((state) => state.authReducer);

  // console.log("appStore", appStore);

  return (
    <>
      <Sider collapsed={collapsed} width={220} style={{ backgroundColor: '#E8EEF0' }}>

        <div className="flex justify-center items-center mt-2 ">
          <img
            className="rounded-full object-cover"
            src={getImageUrl(process.env.REACT_APP_BASEURL, appStore?.CompanyLogo)}
            alt="Brand Logo"
            style={{
              height: collapsed ? '50px' : '100px',
              width: collapsed ? '50px' : '100px',
              minWidth: collapsed ? '50px' : '100px',
              transition: 'height 0.2s, width 0.2s',
            }}
            onError={(e) => { e.target.src = '/ygen.png' }}
          />
        </div>

        <Menu mode="inline" style={{ borderRight: 0, padding: 5, backgroundColor: '#E8EEF0', minHeight: '100%' }}>
          {appStore?.menuList
            .filter((item) => item.Parent_Id === null)
            .map((item) => (
              <SubMenu
                key={item.MenuId}
                title={
                  <span className='flex items-center gap-2'>
                    {item.IconClass && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div dangerouslySetInnerHTML={{ __html: item.IconClass }} />
                      </div>
                    )}
                    {!collapsed && (
                      <span style={{ display: 'flex', alignItems: 'center' }}>
                        {item.Menu_URL ? (
                          <Link style={{ color: 'black', fontSize: '16px' }} to={item.Menu_URL}>
                            {item.Menu_Name}
                          </Link>
                        ) : (
                          item.Menu_Name
                        )}
                      </span>
                    )}
                  </span>
                }
              >
                {appStore?.menuList
                  .filter((subItem) => subItem.Parent_Id === item.MenuId)
                  .map((subItem) => (
                    <Menu.Item key={subItem.MenuId}>
                      {subItem.Menu_URL ? <Link to={subItem.Menu_URL}>{subItem.Menu_Name}</Link> : subItem.Menu_Name}
                    </Menu.Item>
                  ))}
              </SubMenu>
            ))}
        </Menu>

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          v {packageJson.version}
        </div>

      </Sider>

    </>);
};

export default Sidebar;
